import styles from "./styles";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";
import Star from "../../assets/star-mobile.svg";

export default function Description() {
  const translate = useTranslate(useLocaleProvider());

  return (
    <div className={styles.textContainer}>
      <h1 className={styles.title}>{translate("ourapps_title")}</h1>
      <p className={styles.subtitle}>{translate("ourapps_subtitle")}</p>
      <div>
        <div className={styles.buttons}>
          <div className={styles.qrCode}></div>
          <div className={styles.appStore}>
            <a
              id="app-store"
              href="https://apps.apple.com/gb/app/asos/id457876088"
              aria-label={translate("ourApps_hero_appStoreIconAriaLabel")}
            >
              <div className={styles.storeIconContainer}>
                <img
                  src={
                    "https://content.asos-media.com/-/media/app-download/apple-app-store.png"
                  }
                  alt={translate("ourapps_hero_appstore_icon")}
                  className={styles.appStoreIcon}
                />
              </div>
            </a>
            <a
              id="google-play"
              href="https://play.google.com/store/apps/details?id=com.asos.app"
              aria-label={translate("ourApps_hero_googlePlayIconAriaLabel")}
            >
              <div className={styles.storeIconContainer}>
                <img
                  src={
                    "https://content.asos-media.com/-/media/app-download/google-play.png"
                  }
                  alt={translate("ourapps_hero_googleplay_icon")}
                  className={styles.googlePlayIcon}
                />
              </div>
            </a>
          </div>
        </div>
        <div className={styles.ratingContainer}>
          <div className={styles.rating}>
            {Array.from({ length: 5 }).map((_, index) => (
              <Star key={index} className={styles.star} />
            ))}
          </div>
          <p className={styles.ratingDescription}>
            {translate("ourapps_rating_text")}
          </p>
        </div>
      </div>
    </div>
  );
}
